import { div, esc, num, pct } from '../calc/format.js';
import { el, emptyRow } from './dom.js';

/* ---- Kvittoleverans ----
   En mening om hur kvitton levererades och en tabell per kassör. Det man
   kan göra något åt är vem som erbjuder kvitto via e-post. */

export function renderReceipts(s, has){
  el('deliverySummary').hidden = !has;
  if(!has){
    ['kPrint','kEmail','kTrash'].forEach(i => el(i).textContent = '–');
    el('kPaper').textContent = '';
    el('tDeliveryCashier').innerHTML = emptyRow(5,'Inga kvitton i urvalet');
    return;
  }
  el('kPrint').textContent = pct(s.printShare);
  el('kEmail').textContent = pct(s.emailShare);
  el('kTrash').textContent = pct(s.trashShare);
  el('kPaper').textContent = s.extraCopies
    ? `Totalt ${num(s.paperSlips)} papperskvitton: ${num(s.printedReceipts)} original och ${num(s.extraCopies)} ${s.extraCopies === 1 ? 'kopia' : 'kopior'}.`
    : `Totalt ${num(s.paperSlips)} papperskvitton, utan extra kopior.`;
  renderDeliveryByCashier(s);
}

export function renderDeliveryByCashier(s){
  const rows = [...s.deliveryByCashier.entries()]
    .map(([name,d]) => ({name, ...d}))
    .sort((a,b) => b.total - a.total);

  let html = `<thead><tr><th>Kassör</th><th class="num">Kvitton</th><th class="num">Papper</th>
    <th class="num">E-post</th><th class="num">Bortvalt</th></tr></thead><tbody>`;

  if(!rows.length){
    html += emptyRow(5,'Inga kvitton i urvalet');
  }else{
    for(const r of rows){
      const emailShare = div(r.EMAIL, r.total)*100;
      html += `<tr>
        <td class="name">${esc(r.name)}</td>
        <td class="num">${esc(num(r.total))}</td>
        <td class="num">${esc(pct(div(r.PRINTER, r.total)*100))}</td>
        <td class="num">${esc(pct(emailShare))}</td>
        <td class="num">${esc(pct(div(r.TRASH_CAN, r.total)*100))}</td>
      </tr>`;
    }
  }
  el('tDeliveryCashier').innerHTML = html + '</tbody>';
}
